import { render } from "./UpdateUserModal.vue?vue&type=template&id=c965ac88&ts=true"
import script from "./UpdateUserModal.vue?vue&type=script&lang=ts"
export * from "./UpdateUserModal.vue?vue&type=script&lang=ts"

import "./UpdateUserModal.vue?vue&type=style&index=0&id=c965ac88&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__